import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useCategoryData } from '../hooks/useMenuData';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const CategoryPage = () => {
  const { categoryId } = useParams();
  const { category, loading, error } = useCategoryData(categoryId);
  const [containerRef, isIntersecting] = useIntersectionObserver();
  
  // Check if device is mobile for reduced animation delays
  const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const animationDelay = isMobile ? 0.05 : 0.1;

  if (loading) {
    return (
      <div className="category-page loading-container" ref={containerRef}>
        <Link to="/" className="back-button">← Back to Menu</Link>
        <div className="loading-spinner"></div>
        <p>Loading category...</p>
      </div>
    );
  }

  if (!category || (error && !category)) {
    return (
      <div className={`category-page ${isIntersecting ? 'fade-in-active' : ''}`} ref={containerRef}>
        <Link to="/" className="back-button">← Back to Menu</Link>
        <div className="category-header">
          <h1 className="category-name">Category Not Found</h1>
        </div>
      </div>
    );
  }

  return (
    <div className={`category-page ${isIntersecting ? 'fade-in-active' : ''}`} ref={containerRef}>
      <Link to="/" className="back-button">← Back to Menu</Link>
      
      <div className="category-header">
        <h1 className="category-name">{category.name}</h1>
        <div className="category-subtitle">{category.description}</div>
      </div>

      <div className="menu-items">
        {category.items.map((item, index) => (
          <div 
            key={index} 
            className={`menu-item ${isIntersecting ? 'fade-in-up-active' : ''}`}
            style={{ animationDelay: `${(index + 1) * animationDelay}s` }}
          >
            <div className="item-content">
              <div className="item-info">
                <div className="item-name">{item.name}</div>
                {item.description && (
                  <div className="item-description">{item.description}</div>
                )}
              </div>
              <div className="item-price">{item.price}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryPage;
